<template>
  <div class="col-12 pg-login">
    <div class="form-login col-12 row col-md-4 px-0">
      <form class="mb-3 w-100" @submit.prevent="register">

        <div class="col-12 d-flex justify-content-center my-4">
          <img alt="Akdemica logo" height="100" src="../../assets/img/logo-completa.png">
        </div>

        <div id="registerTabs" class="carousel slide" data-ride="false" data-pause="true" >
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="col-12">
                <label><small>Nome Completo</small></label>
                <input
                  v-model="form.name"
                  class="form-control"
                  type="text"
                  :class="{ 'is-invalid': form.errors.has('name') }"
                  name="name"
                />
                <has-error :form="form" field="name"></has-error>
              </div>

              <div class="col-12">
                <label><small>CPF / CNPJ</small></label>
                <input
                  type="tel"
                  v-model="form.document"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  class="form-control"
                  :class="{ 'is-invalid': form.errors.has('document') || !form.document }"
                  name="document"
                />
                <!-- <input
                  v-model="form.document"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  class="form-control"
                  :class="{ 'is-invalid': form.errors.has('document') }"
                  name="name"
                /> -->
                <has-error :form="form" field="document"></has-error>
              </div>

              <div class="col-12">
                <label><small>Email</small></label>
                <input
                  v-model="form.email"
                  class="form-control"
                  type="email"
                  :class="{ 'is-invalid': form.errors.has('email') }"
                  name="email"
                />
                <has-error :form="form" field="email"></has-error>
              </div>

              <div class="col-12">
                <label><small>Senha</small></label>

                <div class="input-group">
                  <input
                    v-model="form.password"
                    class="form-control"
                    :type="pass_type"
                    :class="{ 'is-invalid': form.errors.has('password') }"
                    name="password"
                  />
                  <div class="input-group-append bg-white">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @mousedown="showPassWord"
                      @mouseup="hidePassWord"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </div>
                </div>
                <has-error :form="form" field="password"></has-error>
              </div>

              <div class="col-12">
                <label><small>Foto do Perfil</small></label>

                <div class="custom-file">
                  <input
                    type="file"
                    :class="{ 'custom-file-input': true, 'is-invalid': form.errors.has('picture') }"
                    id="picture"
                    accept="image/png, image/jpeg"
                    @change="loadPicture($event)"
                  />
                  <label class="custom-file-label" for="customFileLang">{{ filename }}</label>
                </div>
                <has-error :form="form" field="picture"></has-error>
              </div>

              <div class="col-12">
                <div class="preview-interface rounded d-flex justify-content-center border border-dark" v-if="filePreview">
                  <img class="preview" :src="filePreview">
                </div>
              </div>

              <div class="col-12">
                <div class="progress my-2" v-if="uploading">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :style="`width: ${ progress }%;`"
                    :aria-valuenow="progress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >{{ progress }}%</div>
                </div>
              </div>

              <div class="col-12 mt-2">
                <div
                  class="custom-control custom-checkbox"
                  :class="{'is-invalid': form.errors.has('read_confirmation')}"
                >
                  <input
                    type="checkbox"
                    id="usage"
                    class="custom-control-input"
                    v-model="form.read_confirmation"
                    :class="{'is-invalid': form.errors.has('read_confirmation')}"
                  />
                  <label class="custom-control-label" for="usage">Eu li e concordei com os &nbsp;</label>
                  <a class="" href="/termos-de-uso" target="_blank">Termos de Uso da Akdemica</a>
                </div>
                <has-error :form="form" field="read_confirmation"></has-error>
              </div>

              <div class="col-12 mt-2">
                <div class="d-flex justify-content-between">
                  <a class="btn btn-secondary" href="/login"><b>Voltar Para Login</b></a>
                  <button class="btn btn-success px-5" type="button" @click="nextPage"><b>Proximo</b></button>
                </div>
              </div>
            </div>

            <div class="carousel-item">
              <div class="col-12 text-center">
                <p>Nos fale do que você gosta.</p>
              </div>

              <div class="col-12 mt-2">
                <tags ref="tags" />
              </div>

              <div class="col-12">
                <div class="d-flex justify-content-between">
                  <a href="#" class="pt-2" @click="prevPage"><b>Voltar</b></a>
                  <button class="btn btn-success px-5" type="submit"><b>Cadastrar</b></button>
                </div>
              </div>
            </div>

            <div class="carousel-item">
              <div class="col-12 text-center">
                <h2>Tudo certo!</h2>
                <h4>Só falta confirmar o seu email.</h4>
                <p>Você já pode navegar pelo nosso conteudo</p>
                <a href="/login" class="btn btn-success">Voltar para o Login</a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Axios from "axios"
import Form from 'vform'
import Tags from './../../components/general/Tags'
import hash from 'hash.js'
import { mask } from 'vue-the-mask'

export default {
  directives: {
    mask
  },
  components: {
    "tags": Tags
  },
  data () {
    return {
      filename: "Procurar Arquivo",
      file: undefined,
      filePreview: undefined,
      progress: 0,
      uploading: false,

      pass_type: "password",

      form: new Form({
        name: undefined,
        email: undefined,
        password: undefined,
        picture: undefined,
        document: undefined,
        type: 'STD',
        icon: 'STD',
        read_confirmation: false,
        is_actived: true
      }),
    }
  },
  methods: {
    loadPicture: function (event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        this.file = input.files[0];
        var reader = new FileReader();
        reader.onload = (e) => {
            this.filePreview = e.target.result;
        }
        reader.readAsDataURL(input.files[0]);
      }
    },

    uploadFile: function (user_id) {
      this.uploading = true

      var bodyFormData = new FormData();
      bodyFormData.set('user_id', user_id)
      bodyFormData.append('file', this.file)

      Axios.post(`/register/user/upload`,
        bodyFormData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progress => {
            this.progress = ((progress.loaded * 100) / progress.total).toFixed(0)
          }
        }
      )
        .then( res => console.log(res))
        .catch( err => console.error(err))
    },

    getSelectedTag: function () {
      let items = this.$refs.tags.items.filter( item => {
        return item.selected === true
      })
      return items
    },

    register: function () {
      let tags = this.getSelectedTag()
      this.form.tags = tags

      let pass = this.form.password
      this.form.password = hash.sha256().update(pass).digest('hex')

      this.form.post("/register/user")
        .then( res => {
          if ( this.file ) this.uploadFile(res.data.data.id)
          this.nextPage()
        })
        .catch( err => {
          this.form.password = pass
          this.prevPage()
        })
    },

    prevPage: function () {
      $("#registerTabs").carousel('prev')
    },

    nextPage: function () {
      $("#registerTabs").carousel('next')
    },

    showPassWord: function () {
      this.pass_type = "text"
    },

    hidePassWord: function () {
      this.pass_type = "password"
    }
  },
  mounted() {

  }
}
</script>
